import DataTablePagination from "./DataTablePagination";
import DataTableFilter from "./DataTableFilter";
import DataTableRow from "./DataTableRow"; // Import the new component
import StandardEmpty from "../empty/StandardEmpty";

function DateTableBody({
  headers,
  rows,
  currentPage,
  totalPages,
  onPageChange,
  sortConfig,
  onSort,
  filterElement,
  onFilterClick,
  getActionMenu,
  rowDefaults = {},
  emptyStateText = "Nothing to show",
  copy,
}) {
  return (
    <>
      <div className="standard-data-table-content">
        {/* HEADER */}
        <div className="standard-data-table-header-wrapper header-only-wrapper">
          <div className="standard-data-table-content-row">
            {headers.map((header, index) => {
              const sortDirection =
                sortConfig?.key === header.key ? sortConfig.direction : null;

              return (
                <div
                  key={index}
                  className="standard-data-table-content-row-field"
                  role={header.sortable ? "button" : undefined}
                  tabIndex={header.sortable ? 0 : undefined}
                  aria-sort={
                    sortDirection
                      ? sortDirection === "asc"
                        ? "ascending"
                        : "descending"
                      : undefined
                  }
                  onClick={() => onSort?.(header)}
                  onKeyDown={(event) => {
                    if (
                      header.sortable &&
                      (event.key === "Enter" || event.key === " ")
                    ) {
                      event.preventDefault();
                      onSort?.(header);
                    }
                  }}
                  style={{
                    flex: `0 0 ${header.width}`,
                    width: header.width,
                    cursor: header.sortable ? "pointer" : "default",
                  }}
                >
                  <h4 className="standard-data-table-content-header-title">
                    {header.label}
                  </h4>
                  {header.sortable && (
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/arrow_downward_sort.svg`}
                      alt={
                        sortDirection
                          ? `Sorted ${sortDirection}`
                          : `Sort by ${header.label}`
                      }
                      style={{
                        width: "16px",
                        height: "16px",
                        padding: "4px",
                        backgroundColor: "#ebf5ff",
                        transform:
                          sortDirection === "asc" ? "rotate(180deg)" : "none",
                        opacity: sortDirection ? 1 : 0.6,
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
          <div
            className="standard-table-fixed-row-right-element"
            style={{ boxShadow: "none", background: "white" }}
          >
            {filterElement && <DataTableFilter onFilterClick={onFilterClick} />}
          </div>
        </div>

        {/* BODY */}
        <div className="standard-data-table-content-row-container">
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <DataTableRow
                key={row.uuid || rowIndex}
                row={row}
                headers={headers}
                rowDefaults={rowDefaults}
                getActionMenu={getActionMenu}
                copy={copy}
              />
            ))
          ) : (
            <div className="standard-data-table-empty-state">
              <StandardEmpty msg={emptyStateText} />
            </div>
          )}
        </div>
      </div>

      <DataTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </>
  );
}

export default DateTableBody;
